export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="large menuExchange">TYPE</div>
      <div className="large menuSellQty">SYMBOL</div>
      <div className="large menuSellQty">QTY</div>
      <div className="large menuSellQty">RATE</div>
      <div className="large menuSymbol">MSG</div>
      <div className="large menuLtt">DATE</div>
    </div>
  );
}
